import { useMutation } from "@tanstack/react-query";

import { deleteConsentDocument } from "../api/consentDocuments";

export const useDeleteConsentDocument = () => {
  return useMutation({
    mutationFn: deleteConsentDocument,
  });
};
